(function () {
  'use strict';

  var CFG           = window.UPS_CONFIG || {};
  var SUPABASE_URL  = CFG.supabaseUrl || '';
  var SUPABASE_KEY  = CFG.supabaseKey || '';
  var SUPABASE_BUCKET = 'File Uploads';

  var pendingFile = null;

  function $(id) { return document.getElementById(id); }
  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }

  function setError(id, msg) {
    var el = $(id);
    if (!el) return;
    el.textContent = msg;
    el.hidden = !msg;
  }

  function clearErrors() {
    ['ups-file-error','ups-size-error','ups-submit-errors'].forEach(function (id) {
      setError(id, '');
    });
  }

  // ─── File select — preview only ────────────────────────────────────────────
  function handleFileChange(file) {
    if (!file) return;
    pendingFile = file;

    var filename    = $('ups-upload-filename');
    var selected    = $('ups-upload-selected');
    var placeholder = $('ups-upload-placeholder');
    var previewImg  = $('ups-preview-img');
    var fallback    = $('ups-preview-fallback');

    if (filename) filename.textContent = file.name;
    hide(placeholder);
    show(selected);

    var imageTypes = ['image/png','image/jpeg','image/gif','image/webp','image/svg+xml'];
    if (imageTypes.indexOf(file.type) !== -1) {
      var reader = new FileReader();
      reader.onload = function (e) {
        if (previewImg) { previewImg.src = e.target.result; show(previewImg); }
        hide(fallback);
      };
      reader.readAsDataURL(file);
    } else {
      hide(previewImg);
      show(fallback);
    }

    var propFile = $('ups-prop-file-url');
    if (propFile) propFile.value = '';
    setError('ups-file-error', '');
  }

  function resetFileInput() {
    pendingFile = null;
    var input       = $('ups-file-input');
    var placeholder = $('ups-upload-placeholder');
    var selected    = $('ups-upload-selected');
    var previewImg  = $('ups-preview-img');
    var propFile    = $('ups-prop-file-url');
    if (input)    input.value = '';
    if (propFile) propFile.value = '';
    show(placeholder);
    hide(selected);
    if (previewImg) { previewImg.src = ''; hide(previewImg); }
  }

  // ─── Resize visibility ─────────────────────────────────────────────────────
  function updateResizeVisibility() {
    var checked = document.querySelector('[name="ups-resize"]:checked');
    var section = $('ups-resize-section');
    if (checked && checked.value === 'yes') {
      show(section);
    } else {
      hide(section);
      var sizeVal = $('ups-size-value');
      if (sizeVal) sizeVal.value = '';
      setError('ups-size-error', '');
    }
  }

  // ─── Build resize property value ───────────────────────────────────────────
  function getResizeValue() {
    var checked = document.querySelector('[name="ups-resize"]:checked');
    if (!checked || checked.value !== 'yes') return '';
    var num  = $('ups-size-value');
    var unit = $('ups-size-unit');
    var dim  = $('ups-size-dimension');
    var n = num ? num.value.trim() : '';
    if (!n) return '';
    var unitLabel = (unit && unit.value === 'cm') ? 'cm' : 'inch';
    var dimLabel  = (dim  && dim.value  === 'Height') ? 'tall' : 'wide';
    return n + ' ' + unitLabel + ' ' + dimLabel;
  }

  // ─── Validation ────────────────────────────────────────────────────────────
  function validate() {
    clearErrors();
    var valid = true;

    if (!pendingFile) {
      setError('ups-file-error', 'Please upload your artwork file.');
      valid = false;
    }

    var checked = document.querySelector('[name="ups-resize"]:checked');
    if (checked && checked.value === 'yes') {
      var sizeVal = $('ups-size-value');
      if (!sizeVal || !sizeVal.value.trim()) {
        setError('ups-size-error', 'Please enter the size you need.');
        valid = false;
      }
    }

    return valid;
  }

  // ─── Upload to Supabase ────────────────────────────────────────────────────
  function uploadFile(file, onSuccess, onError) {
    var progress = $('ups-upload-progress');
    var fill     = $('ups-progress-fill');
    var status   = $('ups-upload-status');
    show(progress);
    if (fill)   fill.style.width = '0%';
    if (status) status.textContent = 'Uploading\u2026';

    var ext           = file.name.split('.').pop();
    var uniqueName    = Date.now() + '-' + Math.random().toString(36).slice(2) + '.' + ext;
    var encodedBucket = encodeURIComponent(SUPABASE_BUCKET);
    var uploadUrl     = SUPABASE_URL + '/storage/v1/object/' + encodedBucket + '/' + uniqueName;
    var publicUrl     = SUPABASE_URL + '/storage/v1/object/public/' + encodedBucket + '/' + uniqueName;

    var xhr = new XMLHttpRequest();
    xhr.open('POST', uploadUrl, true);
    xhr.setRequestHeader('Authorization', 'Bearer ' + SUPABASE_KEY);
    xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream');

    xhr.upload.onprogress = function (e) {
      if (e.lengthComputable && fill) {
        fill.style.width = Math.round((e.loaded / e.total) * 100) + '%';
      }
    };

    xhr.onload = function () {
      hide(progress);
      if (xhr.status >= 200 && xhr.status < 300) {
        var propFile = $('ups-prop-file-url');
        if (propFile) propFile.value = publicUrl;
        onSuccess();
      } else {
        var msg = 'File upload failed. Please try again.';
        try { var e = JSON.parse(xhr.responseText); msg = e.message || e.error || msg; } catch (ex) {}
        onError(msg);
      }
    };

    xhr.onerror = function () {
      hide(progress);
      onError('Upload error. Check your connection and try again.');
    };

    xhr.send(file);
  }

  // ─── Submit ────────────────────────────────────────────────────────────────
  function handleSubmit(e) {
    e.preventDefault();
    if (!validate()) {
      var firstErr = document.querySelector('#ups-cart-form .dtf-error:not([hidden])');
      if (firstErr) firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    var btn     = $('ups-submit-btn');
    var label   = $('ups-submit-label');
    var loading = $('ups-submit-loading');
    var errBox  = $('ups-submit-errors');

    if (btn) btn.disabled = true;
    hide(label);
    show(loading);
    hide(errBox);

    uploadFile(
      pendingFile,
      function onSuccess() {
        // Set resize property before building FormData
        var propResize = $('ups-prop-resize');
        if (propResize) propResize.value = getResizeValue();

        var form = $('ups-cart-form');
        var data = new FormData(form);

        fetch('/cart/add.js', {
          method: 'POST',
          body: data,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || 'Cart error'); });
            return res.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
            if (btn) btn.disabled = false;
            show(label);
            hide(loading);

            // Reset form
            resetFileInput();
            var notes = $('ups-notes');
            if (notes) notes.value = '';
            var noRadio = document.querySelector('[name="ups-resize"][value="no"]');
            if (noRadio) { noRadio.checked = true; updateResizeVisibility(); }

            window.scrollTo({ top: 0, behavior: 'smooth' });

            var drawerEl = document.querySelector('cart-drawer-component');
            if (drawerEl && typeof drawerEl.open === 'function') {
              drawerEl.open();
            } else {
              document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
            }
          })
          .catch(function (err) {
            if (btn) btn.disabled = false;
            show(label);
            hide(loading);
            if (errBox) { errBox.textContent = err.message || 'Something went wrong. Please try again.'; show(errBox); }
          });
      },
      function onError(msg) {
        if (btn) btn.disabled = false;
        show(label);
        hide(loading);
        setError('ups-file-error', msg);
      }
    );
  }

  // ─── Drag and drop ─────────────────────────────────────────────────────────
  function initDragDrop() {
    var area  = $('ups-upload-area');
    var input = $('ups-file-input');
    if (!area || !input) return;
    area.addEventListener('click', function (e) {
      if (e.target === input) return;
      input.click();
    });
    area.addEventListener('dragover',  function (e) { e.preventDefault(); area.classList.add('dtf-upload-area--drag'); });
    area.addEventListener('dragleave', function ()  { area.classList.remove('dtf-upload-area--drag'); });
    area.addEventListener('drop', function (e) {
      e.preventDefault();
      area.classList.remove('dtf-upload-area--drag');
      if (e.dataTransfer.files.length > 1) {
        alert('You can only upload 1 image at a time. Please fill out a separate form for each design.');
        return;
      }
      var file = e.dataTransfer.files[0];
      if (file) handleFileChange(file);
    });
  }

  // ─── Preview modal ─────────────────────────────────────────────────────────
  function initPreviewModal() {
    var dialog    = $('ups-preview-dialog');
    var dialogImg = $('ups-preview-dialog-img');
    var closeBtn  = $('ups-preview-dialog-close');
    var thumb     = $('ups-preview-img');
    if (!dialog) return;
    if (thumb) {
      thumb.addEventListener('click', function () {
        if (dialogImg) dialogImg.src = thumb.src;
        dialog.showModal();
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  }

  // ─── Init ──────────────────────────────────────────────────────────────────
  function init() {
    var form = $('ups-cart-form');
    if (!form) return;

    var fileInput = $('ups-file-input');
    if (fileInput) {
      fileInput.addEventListener('change', function () {
        handleFileChange(fileInput.files[0] || null);
      });
    }

    var removeBtn = $('ups-remove-file');
    if (removeBtn) {
      removeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        resetFileInput();
        setError('ups-file-error', '');
      });
    }

    // Size input — numbers and periods only
    var sizeVal = $('ups-size-value');
    if (sizeVal) {
      sizeVal.addEventListener('input', function () {
        var clean = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
        if (this.value !== clean) this.value = clean;
      });
    }

    // Resize radios
    document.querySelectorAll('[name="ups-resize"]').forEach(function (r) {
      r.addEventListener('change', updateResizeVisibility);
    });

    form.addEventListener('submit', handleSubmit);
    initDragDrop();
    initPreviewModal();
    updateResizeVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();